import React from 'react';

const HomePageFooter = () => (
  <div
    style={{
      width: '100%',
      padding: '0.5rem 1rem',
      textAlign: 'center',
      background: 'var(--slds-g-color-palette-electric-blue-20)',
      borderTop: '1px solid var(--slds-g-color-border-1, #e0e0e0)',
      color: '#fff',
      position: 'fixed',
      bottom: 0,
      left: 0,
      zIndex: 1000
    }}
  >
    <span style={{fontSize: '0.95rem'}}>© {new Date().getFullYear()} Salesforce Lightning Design System</span>
  </div>
);

export default HomePageFooter; 